import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconBarGraph = createIcon({
  displayName: 'IconBarGraph',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M21 3H19V21H21V3ZM13 11H11V21H13V11ZM5 19H3V21H5V19ZM7 15H9V21H7V15ZM15 7H17V21H15V7Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
